import React from "react"
import PropTypes from 'prop-types';
import CalcInput from "../components/CalcInput"
import rehypeReact from 'rehype-react'
import equations from '../../.cache/equations.js'
import {Decimal} from 'decimal.js';

class mdCalcPage extends React.Component {
  constructor(props){
    super()
    let inputs = props.data.markdownRemark.fields.inputsPretty
    let outputs = props.data.markdownRemark.fields.outputsPretty
    Decimal.set({ precision: 5})
    this.state = {hash: props.pathContext.hash, seed: new Decimal(0)}
    inputs.forEach(input => {
      try {
        this.state[input.sanitized] = new Decimal(input.default)
      } catch(error) {
        this.state[input.sanitized] = new Decimal(0)
      }
    })
    if (outputs) {
      outputs.forEach(output => {
          this.state[output.sanitized] = new Decimal(0)
      })
    }
    this.state = {...this.state, ...equations[this.state.hash](this.state).val}
  }

  getChildContext() {
    return {calcVariables: this.state}
  }

  handleChildChange(input, value) {
    let nextState = {...this.state}
    try {
      nextState[input] = new Decimal(value)
    } catch (error) {
      nextState[input] = new Decimal(0)
    }
    let newCalcVals = equations[nextState.hash](nextState).val
    this.setState({...nextState, ...newCalcVals})
  }

  render() {
    const {htmlAst, frontmatter, fields} = this.props.data.markdownRemark

    const renderAst = new rehypeReact({
        createElement: React.createElement,
        components: {
          "equation-input": EquationInput,
          "equation-output": EquationOutput
        },
      }).Compiler

    let Inputs = fields.inputsPretty.map((input) => {
      return <CalcInput
              key={input.sanitized}
              onChange={this.handleChildChange.bind(this, input.sanitized)}
              value={this.state[input.sanitized]}
              eqprop={input.sanitized}
              {...{input: input.pretty}}/>
    }) 

    return (
      <div className="box">
        <h1 className="title">{frontmatter.title}</h1>
        <div className="container is-fluid">
          <hr/>
          <h1 className="subtitle">Inputs:</h1>
          <form>
            {Inputs}
          </form>
          <hr/>
        </div>
        <div className="container is-fluid">
          <div className="content">
            <div>{renderAst(htmlAst)}</div>
          </div>
        </div>
      </div>
    )
  }
}

mdCalcPage.childContextTypes = {
  calcVariables: PropTypes.object
}

export default mdCalcPage

class EquationOutput extends React.Component {
  render () {
    return (
      <span>{this.context.calcVariables[this.props.eqprop].toPrecision(5)}</span>
    )
  }
}

EquationOutput.contextTypes = {
  calcVariables: PropTypes.object
}

const EquationInput = (props) => {
  console.log(this)
  console.log(props)
  return <span>text stuff</span>
  // return <span dangerouslySetInnerHTML={{__html: props.html}} />
}

let killError = (val) => {
  if (val == undefined) {
    return ``
  } else if (val.isNaN()) {
    return ` ----`
  } else {
    return val
  }
}

export const pageQuery = graphql`
  query markdownCalcTemplateBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      htmlAst
      frontmatter {
        title
      }
      fields {
        inputsPretty {
          name
          sanitized
          pretty
          default
        }
        outputsPretty {
          name
          expected
          sanitized
          pretty
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/mdCalcPage.js